import { useState } from 'react';
import {
  Card,
  Container,
  Stack,
  Link,
  Typography,
  TextField,
  Select,
  MenuItem,
  Tooltip,
  IconButton,
  Button,
  Grid,
  FormControl,
  InputLabel
} from '@mui/material';
import { Icon } from '@iconify/react';
import add from '@iconify/icons-ic/add';
import remove from '@iconify/icons-ic/sharp-minus';
import { Box } from '@mui/system';
import { Link as RouterLink, useParams } from 'react-router-dom';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';

function AddEditLeads() {
  const { rowId } = useParams();
  const [masterValue, setMasterValue] = useState([{ masterValue: '' }]);
  const [refreshComp, setRefreshComp] = useState(null);
  const [loanInterested, setLoanInterested] = useState(' ');
  const [amountValue, setAmountValue] = useState('');
  const [bankPreference, setBankPreference] = useState(' ');
  const [sourceValue, setSourceValue] = useState(' ');
  const [mobileNumber, setMobileNumber] = useState('');
  const [nameValue, setNameValue] = useState('');
  const [cityName, setCityName] = useState('');

  const addMoreMasterValue = () => {
    const prevValue = masterValue;
    const obj = { masterValue: '' };
    prevValue.push(obj);
    setMasterValue(prevValue);
    setRefreshComp(new Date());
  };
  const removeMasterValue = (index) => {
    const prevValue = masterValue;
    const removedItem = prevValue.filter((elm, ind) => ind !== index);
    setMasterValue(removedItem);
    setRefreshComp(new Date());
  };
  return (
    <Page title="Kpros by Kalolytic Solutions || Leads">
      <Container maxWidth="xl">
        <Box pt={3} pb={3}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <PageTitle info={rowId ? 'Edit Leads' : 'Add New Leads'} />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Card>
            <Scrollbar>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="formRowHolder fullrow">
                    <Typography variant="h6" className="formLabel">
                      Full Name
                    </Typography>
                    <TextField
                      fullWidth
                      inputProps={{
                        className: 'textInput'
                      }}
                      placeholder="Type mobile number..."
                      value={mobileNumber}
                      onChange={(event) => setMobileNumber(event.target.value)}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="formRowHolder fullrow">
                    <Typography variant="h6" className="formLabel">
                      E-Mail
                    </Typography>
                    <TextField
                      fullWidth
                      inputProps={{
                        className: 'textInput'
                      }}
                      placeholder="Type name..."
                      value={nameValue}
                      onChange={(event) => setNameValue(event.target.value)}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="formRowHolder fullrow">
                    <Typography variant="h6" className="formLabel">
                      Phone Number
                    </Typography>
                    <TextField
                      fullWidth
                      inputProps={{
                        className: 'textInput'
                      }}
                      placeholder="Type city..."
                      value={cityName}
                      onChange={(event) => setCityName(event.target.value)}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="formRowHolder fullrow">
                    <Typography variant="h6" className="formLabel">
                      Date of Birth
                    </Typography>
                    <TextField
                      fullWidth
                      inputProps={{
                        className: 'textInput'
                      }}
                      placeholder="Type city..."
                      value={cityName}
                      onChange={(event) => setCityName(event.target.value)}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="formRowHolder fullrow">
                    <Typography variant="h6" className="formLabel">
                      City
                    </Typography>
                    <TextField
                      fullWidth
                      inputProps={{
                        className: 'textInput'
                      }}
                      placeholder="Type city..."
                      value={cityName}
                      onChange={(event) => setCityName(event.target.value)}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="formRowHolder fullrow">
                    <Typography variant="h6" className="formLabel">
                      Employment Type
                    </Typography>
                    <Select
                      fullWidth
                      inputProps={{
                        className: 'textInput'
                      }}
                      value={loanInterested}
                      onChange={(e) => setLoanInterested(e.target.value)}
                    >
                      <MenuItem value=" " disabled>
                        Select
                      </MenuItem>
                      <MenuItem value="homeloan">Home Loan</MenuItem>
                      <MenuItem value="educationloan">Education Loan</MenuItem>
                    </Select>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="formRowHolder fullrow">
                    <Typography variant="h6" className="formLabel">
                      Loan Type
                    </Typography>
                    <Select
                      fullWidth
                      inputProps={{
                        className: 'textInput'
                      }}
                      value={loanInterested}
                      onChange={(e) => setLoanInterested(e.target.value)}
                    >
                      <MenuItem value=" " disabled>
                        Select
                      </MenuItem>
                      <MenuItem value="homeloan">Home Loan</MenuItem>
                      <MenuItem value="educationloan">Education Loan</MenuItem>
                    </Select>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="formRowHolder fullrow">
                    <Typography variant="h6" className="formLabel">
                      Loan Amount
                    </Typography>
                    <TextField
                      type="number"
                      variant="outlined"
                      inputProps={{
                        className: 'textInput'
                      }}
                      placeholder="Type amount..."
                      fullWidth
                      value={amountValue}
                      onChange={(event) => setAmountValue(event.target.value)}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box className="formRowHolder fullrow">
                    <Typography variant="h6" className="formLabel">
                      Lead Type
                    </Typography>
                    <Select
                      fullWidth
                      inputProps={{
                        className: 'textInput'
                      }}
                      value={bankPreference}
                      onChange={(e) => setBankPreference(e.target.value)}
                    >
                      <MenuItem value=" " disabled>
                        Select
                      </MenuItem>
                      <MenuItem value="sbi">SBI</MenuItem>
                      <MenuItem value="axisbank">AXIS BANK</MenuItem>
                    </Select>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="formRowHolder fullrow">
                    <Typography variant="h6" className="formLabel">
                      Prefered Bank
                    </Typography>
                    <Select
                      fullWidth
                      inputProps={{
                        className: 'textInput'
                      }}
                      value={sourceValue}
                      onChange={(e) => setSourceValue(e.target.value)}
                    >
                      <MenuItem value=" " disabled>
                        Select
                      </MenuItem>
                      <MenuItem value="facebook">Facebook</MenuItem>
                      <MenuItem value="callcentre">Call Centre Application</MenuItem>
                    </Select>
                  </Box>
                </Grid>
              </Grid>
              <Box className="formRowHolder">
                <Button variant="contained">Save</Button>
              </Box>
            </Scrollbar>
          </Card>
        </Box>
      </Container>
    </Page>
  );
}
export default AddEditLeads;
